<template>

    <div class="h-full home-box">
        <el-container>
            <el-header>
                <div class="home-top">
                    <h3 class="home-title">全国重点城市仓储市场概览</h3>
                    <span class="home-description">数据时间：{{ time }}</span>
                </div>
            </el-header>

            <el-main>
                <div class="home-content">
                    <MessageHeader msg="城市列表"></MessageHeader>
                    <purchased-city-list />
                    <div>
                        <MessageHeader msg="土地出让动态"></MessageHeader>
                        <LandItem
                            :keys="dataStrArr"
                            :land-chart-list="landChartList"
                            :land-list="landList"
                        />
                        <div class="chart-list">
                            <div class="chart-item">
                                <p class="u-agg-aii-ct">土地出让面积TOP5城市</p>
                                <BarAndLineChart
                                  color="#0A9BFC"
                                  :linearGradient="['rgba(10, 155, 252, 0.8)','rgba(255, 255, 255, 0)']"
                                  :options="['name', 'totalArea', 'price']"
                                  :legends="['出让面积', '成交均价']"
                                  :data="cityList"
                                  :label-format="['（亩）','（万元/亩）']"
                                  :value-format="[landAreaFormat]"
                                  :showLabel="['出让面积', '成交均价']"
                                />
                                <!-- <BarAndLine
                                    title="出让活跃TOP5城市"
                                    :legend-data="['出让面积（亩）', '成交均价(万元/亩)']"
                                    :data="cityList"
                                    :options="['name', 'totalArea', 'price']"
                                    :top="30"
                                    not-show-y-name
                                /> -->
                            </div>
                            <div class="chart-item">
                                <p class="u-agg-aii-ct">土地成交均价TOP5城市</p>
                                <Bars
                                    direction="horizontal"
                                    title="成交均价TOP5城市"
                                    name="单位：万元/亩"
                                    :data="priceList"
                                    color="#14CE96"
                                    custom-tooltip
                                    :customConfig="getCustomTip()"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="home-second-content">
                        <MessageHeader msg="租赁市场动态"></MessageHeader>
                        <div class="home-second-list">
                            <ScrollTable :tableHead="tableHead" :table-data="dynamicsData"></ScrollTable>
                        </div>
                        <div class="lease-chart">
                            <p class="u-agg-aii-ct">租赁市场活跃度TOP10城市</p>
                            <Bars
                                axisLabel
                                notFixed
                                axisLine
                                title="租赁市场活跃度TOP10城市"
                                name="租赁成交面积（㎡）"
                                :data="areaList"
                                custom-tooltip
                                color="#29D5F5"
                                :customConfig="getAreaCustomTip()"
                                :color="['#41D1FF','#0053C2']"/>
                        </div>
<!--                        <div class="home-rank-box">-->
<!--                            <p class="u-agg-aii-ct">季度空置率环比变化top10城市</p>-->
<!--                            <div class="home-rank-index">-->
<!--                                <div class="home-rank-left">-->
<!--                                    <div class="home-rank-ll home-rank-icon-up">-->
<!--                                        <div class="home-rank-type home-rank-ht1">上升</div>-->
<!--                                        <div class="home-rank-ht-list">-->
<!--                                            <div class="home-rank-ht-item" v-for="(item,index) in vacantInfo.upCityList" :key="item.cityCode">-->
<!--                                                <span class="home-rht-item-num home-rht-item-atop home-rht-item-atop1">{{index+1}}</span>-->
<!--                                                <span class="home-rht-item-name" title="xxx">{{item.city}}</span>-->
<!--                                                <span class="home-rht-item-data" title="xxx">{{(item.metricValueMOM*100).toFixed(2)+'%'}}</span>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="home-rank-lr home-rank-icon-down">-->
<!--                                        <div class="home-rank-type home-rank-ht2">下降</div>-->
<!--                                        <div class="home-rank-ht-list">-->
<!--                                            <div class="home-rank-ht-item" v-for="(item,index) in vacantInfo.downCityList" :key="item.cityCode">-->
<!--                                                <span class="home-rht-item-num home-rht-item-btop">{{index+1}}</span>-->
<!--                                                <span class="home-rht-item-name" title="xxx">{{item.city}}</span>-->
<!--                                                <span class="home-rht-item-data" title="xxx">{{(item.metricValueMOM*100).toFixed(2)+'%'}}</span>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--&lt;!&ndash;                                <div class="home-rank-right home-rank-right-column">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <div class="home-rank-scatter">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <span>上升</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <div class="home-rank-scatter-chart">&ndash;&gt;-->
<!--&lt;!&ndash;                                            <ScatterChart&ndash;&gt;-->
<!--&lt;!&ndash;                                                :color="['#FB8818', '#FACDA2', '#FACDA2']"&ndash;&gt;-->
<!--&lt;!&ndash;                                                :data="scatterUpData"&ndash;&gt;-->
<!--&lt;!&ndash;                                            ></ScatterChart>&ndash;&gt;-->
<!--&lt;!&ndash;                                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <div class="home-rank-scatter">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <span>下降</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <div class="home-rank-scatter-chart">&ndash;&gt;-->
<!--&lt;!&ndash;                                            <ScatterChart&ndash;&gt;-->
<!--&lt;!&ndash;                                            :color="['#5AB638', '#C1F7C1', '#C1F7C1']"&ndash;&gt;-->
<!--&lt;!&ndash;                                            :data="scatterDownData"&ndash;&gt;-->
<!--&lt;!&ndash;                                            ></ScatterChart>&ndash;&gt;-->
<!--&lt;!&ndash;                                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="home-rank-box">-->
<!--                            <p class="u-agg-aii-ct">季度预估有效租金环比变化top10城市</p>-->
<!--                            <div class="home-rank-index">-->
<!--                                <div class="home-rank-left">-->
<!--                                    <div class="home-rank-ll home-rank-icon-up">-->
<!--                                        <div class="home-rank-type home-rank-ht1">上升</div>-->
<!--                                        <div class="home-rank-ht-list">-->
<!--                                            <div class="home-rank-ht-item" v-for="(item,index) in effective.upCityList" :key="item.cityCode">-->
<!--                                                <span class="home-rht-item-num home-rht-item-atop home-rht-item-atop1">{{index+1}}</span>-->
<!--                                                <span class="home-rht-item-name" title="xxx">{{item.city}}</span>-->
<!--                                                <span class="home-rht-item-data" title="xxx">{{(item.metricValueMOM*100).toFixed(2)+'%'}}</span>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="home-rank-lr home-rank-icon-down">-->
<!--                                        <div class="home-rank-type home-rank-ht2">下降</div>-->
<!--                                        <div class="home-rank-ht-list">-->
<!--                                            <div class="home-rank-ht-item" v-for="(item,index) in effective.downCityList" :key="item.cityCode">-->
<!--                                                <span class="home-rht-item-num home-rht-item-btop">{{index+1}}</span>-->
<!--                                                <span class="home-rht-item-name" title="xxx">{{item.city}}</span>-->
<!--                                                <span class="home-rht-item-data" title="xxx">{{(item.metricValueMOM*100).toFixed(2)+'%'}}</span>-->
<!--                                            </div>-->

<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--&lt;!&ndash;                                <div class="home-rank-right">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <div class="home-hb-left">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <div class="home-hb-title">上升</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <div class="home-hb-list">&ndash;&gt;-->
<!--&lt;!&ndash;                                            <div class="home-hb-item" v-for="item in effective.upCityList">&ndash;&gt;-->
<!--&lt;!&ndash;                                                <span class="home-hb-name">{{item.city}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                <div class="home-hb-process home-hb-pc1" :style="{width: (item.metricValueMOM*100).toFixed(2)+'%'}"></div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                <span class="home-hb-num">{{(item.metricValueMOM*100).toFixed(2)+'%'}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                            </div>&ndash;&gt;-->

<!--&lt;!&ndash;                                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                    <div class="home-hb-right">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <div class="home-hb-title">下降</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <div class="home-hb-list">&ndash;&gt;-->
<!--&lt;!&ndash;                                            <div class="home-hb-item" v-for="item in effective.downCityList">&ndash;&gt;-->
<!--&lt;!&ndash;                                                <span class="home-hb-name">{{item.city}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                                <div class="home-hb-process home-hb-pc2" :style="{width: (item.metricValueMOM*100).toFixed(2)+'%'}"></div>&ndash;&gt;-->
<!--&lt;!&ndash;                                                <span class="home-hb-num">{{(item.metricValueMOM*100).toFixed(2)+'%'}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                            </div>&ndash;&gt;-->

<!--&lt;!&ndash;                                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </div>-->

                      <top-city-rate-row
                          :vacantUp="vacantInfo.upCityList"
                          :vacantDown="vacantInfo.downCityList"
                          :effectiveUp="effective.upCityList"
                          :effectiveDown="effective.downCityList"
                      />

                    </div>
                    <div class="home-second-content">
                        <div class="report-title">
                            <MessageHeader msg="市场报告"></MessageHeader>
                            <span class="more-btn" @click="toReport">
                                查看更多
                                <i class="iconfont icon-jiantou-xiangyou"></i>
                            </span>
                        </div>
                        <div class="record-list">
                            <el-row :gutter="20">
                                <el-col :xl="8" :lg="12" v-for="item in reportList" :key="item.id">
                                    <ReportItem :row="5" notTip not-download :item="item"></ReportItem>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script setup>
import MessageHeader from '@/components/MessageHeader'
import Bars from '@/components/charts/chartBar'
import ScrollTable from '@/components/scrollTable'
import ReportItem from '@/components/reportItem'
import LandItem from '@/components/landItem'
import {onBeforeUnmount, onMounted, reactive, ref, watch} from "vue";
import request from "@/service/request";
import {
  getHomeCityTrend,
  getHomeData,
  getHomeDynamics,
  getHomeMarketTrend,
  getHomePriceTrend,
  getQuarterPriceRate,
  getQuarterRate,
  getReport,
  GetUserCityList,
  getClientHeadData
} from "@/service/api";
import router from "@/router";
import BarAndLineChart from '@/components/charts/nChartBarAndLine.vue'
import PurchasedCityList from "@/components/purchasedCityList.vue";
import TopCityRateRow from "@/view/components/topCityRateRow.vue";
import {landAreaFormat, warehouseArea} from "@/tool/number";
let time = localStorage.getItem('time')
let mapTime = localStorage.getItem('mapTime')

const dataStrArr = reactive({
    transferArea: {str: '出让面积', unit: '亩', decimal: 2},
    numLandParcelsTransferred: {str: '出让宗地数', decimal: 0},
    averageTransactionPrice: {str: '成交均价', unit: '万元/亩'},

})

// 成交均价TOP5城市 自定义tip
const getCustomTip = () => {
    return [
        {text: '出让宗地数', key: 'counts', fixed: 0, unit: ''},
        {text: '出让面积', key: 'totalarea', fixed: 2, thousandth: true, unit: '（亩）'},
        {text: '成交均价', key: 'value', fixed: 2, unit: '（万元/亩）'},
    ]
}
const getAreaCustomTip = ()=>{
    return [
        {text: '租赁成交面积', key: 'value',  thousandth: true, unit: '（㎡)'},
    ]
}
const landList = ref({})

const landChartList = ref([])

const handleResize = () => {
    // 执行重新加载的操作
    location.reload();
};

/** 土地出让动态 **/
const getWarehouse = async () => {
    let {data} = await request({
        url: getHomeData,
        method: 'get',
    })
    let obj = {}
    for (let key in dataStrArr) {
        obj[key] = data[key]
    }
    landList.value = obj
    landChartList.value = data.landTypeProportion || []
}
const priceList = ref([])
const getPriceTrend = async () => {
    let {data} = await request({
        url: getHomePriceTrend,
    })
    priceList.value = data
}
const cityList = ref([])

const getCityList = async () => {
    let {data} = await request({
        url: getHomeCityTrend,
    })

    cityList.value = (data || []);
}
const areaList = ref([])

const getAreaList = async () => {
    let {data} = await request({
        url: getHomeMarketTrend,
    })
    areaList.value = data
}

let dynamicsData = ref([])
const tableHead = ref([
    {props: 'rowIndex', label: '序号', align: 'center', width: 60, type: 'index', },
    {props: 'tenantName', label: '租户', align: 'left'},
    {props: 'city', label: '城市', width: 90, align: 'left'},
    {props: 'projectName', label: '项目名称', align: 'left'},
    {props: 'statusName', label: '状态', width: 60, align: 'left'},
    {props: 'areaValue', label: '租赁/退租面积（㎡）',width: 160, isArea:true, align: 'left'},
    {props: 'estimatedClosingPrice', label: '预估成交价（元/㎡·月）',width: 180, isEstimatedPrice: true, align: 'center'},
])
/**租赁数据动态**/
const getDynamicsData = async () => {
    let {data} = await request({
        url: getHomeDynamics,
        method: 'get',
    })
    dynamicsData.value = data
}

const reportList = ref([])
const getReportList = async () => {
    let data = await request({
        url: getReport,
        data: {
            pageNum: 1,
            pageSize: 6
        }
    })
    reportList.value = data.rows || []
}
const toReport = () => {
    router.replace('/insight/marketReport')
}


let scatterUpData = ref([])

let scatterDownData = ref([])
// 空置率
let vacantInfo = ref({
    downCityList:[],
    upCityList:[]
})
const getVacant = async () => {
    let {data} = await request({
        url: getQuarterRate,
        method:'post',
        data: {
            quarter:mapTime
        }
    })
    vacantInfo.value = data
}
watch(vacantInfo,(val)=>{
    scatterUpData.value = val.upCityList.map(item=>{
        let arr = []
        arr.push(item.city)
        arr.push(item.metricValueMOM?(item.metricValueMOM*100).toFixed(2):item.metricValueMOM)
        return arr
    })
    scatterDownData.value = val.downCityList.map(item=>{
        let arr = []
        arr.push(item.city)
        arr.push(item.metricValueMOM?(item.metricValueMOM*100).toFixed(2):item.metricValueMOM)
        return arr
    })
})

// 预估有效租金
let effective = ref({
    downCityList:[],
    upCityList:[]
})
const getEffective = async () => {
    let {data} = await request({
        url: getQuarterPriceRate,
        method:'post',
        data: {
            quarter:mapTime
        }
    })
    effective.value = data
}

/*查看已购买的城市列表*/
const purchasedCityList = ref([]);
const getPurchasedCityList = async () => {
    let {data} = await request({
      method: 'get',
      url: GetUserCityList
    })
    purchasedCityList.value = parseAndFormatPurchasedCityList(data);
}
async function getUserInfo() {
    let { data } = await request({
        url: getClientHeadData,
        data: {
            filterateaear: false
        }
    })

    // var end = localStorage.getItem('endTime')
    

    localStorage.setItem("phone", data.phoneNumber || '无');
    localStorage.setItem("email", data.email || '无');
    localStorage.setItem("companyName", data.companyName || '无');
    var newDate=/\d{4}-\d{1,2}-\d{1,2}/g.exec(data.startTime)
    console.log(newDate[0]);
    localStorage.setItem("startTime", newDate[0] || '');
    newDate=/\d{4}-\d{1,2}-\d{1,2}/g.exec(data.endTime)
    localStorage.setItem("endTime", newDate[0] || '');

}
onMounted(async () => {
    // await getPurchasedCityList()
    getUserInfo()
    getReportList()
    getPriceTrend()
    getWarehouse()
    getCityList()
    getDynamicsData()
    getVacant()
    getAreaList()
    getEffective()
    window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize);
});


function parseAndFormatPurchasedCityList({cityVos: v}){
  if(!v || v.length === 0) return [];
  // 从v中取出城市名称
  const len = 6;
  const cities = v.map(e => e.name);
  let n;
  if(cities.length % len === 0){
    n = cities.length / len;
  }else{
    n = parseInt(cities.length / len ) + 1;
  }
  const result = []

 for(let i = 0; i < n; i++){
   let row = [];
   for(let j = 0; j < len; j++){
     let k = i * 6 + j;
     if( k >= cities.length){
       break;
     }
     row.push(cities[k])
   }
   result.push(row);
 }

  console.log(result);
  return result;
}

</script>

<style>
.home-content .u-agg-aii-lbox>.u-agg-aii-legend{
    justify-content: space-between;
}
</style>
<style lang="less" scoped>
.home-box {
    .el-container {
        height: 100%;
        overflow: hidden;

        .el-main {
            margin-top: 20px;
        }
    }
}

.home-top {
    padding-top: 20px;
    text-align: center;
    margin-bottom: 20px;

    .home-title {
        font-size: 22px;
        font-weight: bold;
        color: @text-color-title;
    }

    .home-description {
        display: block;
        text-align: right;
        padding-top: 12px;
        font-size: 14px;
        color: @text-color-primary;
    }
}

.home-content {
    padding-bottom: 40px;

    .chart-list {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;

        .chart-item {
            width: calc(50% - 10px);
            height: 308px;
            background: #FFFFFF;
            box-sizing: border-box;
            padding: 10px 25px;
            display: flex;
            flex-direction: column;
            box-shadow: -4px 4px 23px 1px rgba(75,173,255,0.1);
            border-radius: 10px;

        }
    }

    .home-second-content {
        margin-top: 40px;

        .home-second-list {
            margin-top: 20px;
            width: 100%;
            height: 328px;
            background: #FFFFFF;
            box-sizing: border-box;
            padding: 30px;
            padding-top: 20px;
            box-shadow: -4px 4px 23px 1px rgba(75,173,255,0.1);
            border-radius: 10px;
        }

        .lease-chart {
            margin-top: 20px;
            width: 100%;
            height: 373px;
            background: #FFFFFF;
            box-sizing: border-box;
            padding: 25px 45px 10px 45px;
            display: flex;
            flex-direction: column;
            box-shadow: -4px 4px 23px 1px rgba(75,173,255,0.1);
            border-radius: 10px;
        }

        .report-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;

            .more-btn {
                display: flex;
                align-items: center;
                font-size: 14px;
                cursor: pointer;
                color: #1477C9;

                .icon-jiantou-xiangyou {
                    font-size: 12px;
                }
            }
        }

        .record-list {
            .el-col {
                margin-top: 20px;
            }

            width: 100%;
        }
    }
}

.home-rank-box{
    display: flex;
    flex-direction: column;
    padding: 25px 20px;
    box-shadow: -4px 4px 23px 1px rgba(75,173,255,0.1);
    border-radius: 10px;
    background: #fff;
    margin-top: 20px;
    display: flex;
    box-sizing: border-box;
    height: 542px;
}

.home-rank-index{
    width: 100%;
    height: 100%;
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
}

.home-rank-left{
    width: calc(50% - 15px);
    display: flex;
    justify-content: space-between;
}

.home-rank-ll{
    display: flex;
    flex-direction: column;
    width: calc(50% - 10px);
    background: #FFF7EF url('../assets/images/up.png') no-repeat right bottom;
    border-radius: 10px;
    align-items: center;
}

.home-rank-lr{
    display: flex;
    flex-direction: column;
    width: calc(50% - 10px);
    background: #F4FFF3 url('../assets/images/down.png') no-repeat right bottom;;
    border-radius: 10px;
    align-items: center;
}

.home-rank-right{
    width: calc(50% - 15px);
    display: flex;
    justify-content: space-between;
    &.home-rank-right-column{
        flex-direction: column;
    }
}

.home-rank-scatter{
    height: 47%;
    display: flex;
    flex-direction: column;
    span{
        color: #333;
    }
    .home-rank-scatter-chart{
        height: 100%;
    }
}

.home-hb-left,.home-hb-right{
    width: calc(50% - 25px);
}

.home-hb-title{
    margin-top: 16px;
    color: #333;
}

.home-hb-item{
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #666;
    margin-top: 18px;
    .home-hb-name{
        flex-shrink: 0;
        margin-right: 13px;
    }
    .home-hb-process{
        height: 20px;
        border-radius: 9px;
        &.home-hb-pc1{
            background: #FBA24B;
        }
        &.home-hb-pc2{
            background: #7BE25B;
        }
    }

    .home-hb-num{
        width: 30px;
        flex-shrink: 0;
        margin-left: 10px;
    }
}



.home-rank-type{
    width: 163px;
    height: 31px;
    line-height: 28px;
    text-align: center;
    &.home-rank-ht1{
        background: url('../assets/images/ht1.png') no-repeat;
        color: #99580C;
    }
    &.home-rank-ht2{
        background: url('../assets/images/ht2.png') no-repeat;
        color: #166B13;
    }
}
.home-rank-ht-list{
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    margin-top: 20px;
    
}
.home-rank-ht-item{
    height: 30px;
    display: flex;
    width: 100%;
    align-items: center;
    margin-bottom: 10px;
    .home-rht-item-num{
        font-size: 14px;
        color: #333;
        display: flex;
        justify-content: center;
        width: 31px;
        height: 24px;
        line-height: 24px;
        flex-shrink: 0;
        margin-right: 10px;
        &.home-rht-item-atop{
        }
        &.home-rht-item-btop{
            color: #166B13;
            background: url('../assets/images/ls.png') no-repeat;
            line-height: 22px;
        }
        &.home-rht-item-atop1{
            color: #99580C;
            background: url('../assets/images/zs1.png') no-repeat;
            line-height: 20px;
        }
        &.home-rht-item-atop2{
            color: #99580C;
            background: url('../assets/images/zs2.png') no-repeat;
            line-height: 20px;
        }
        &.home-rht-item-atop3{
            color: #99580C;
            background: url('../assets/images/zs3.png') no-repeat;
            line-height: 22px;
        }
    }
    .home-rht-item-name,.home-rht-item-data{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #666;
        text-align: center;
    }

    .home-rht-item-name{
        width: calc(50% - 15px);
    }

    .home-rht-item-data{
        width: calc(50% - 16px);
        margin-left: 5px;
    }
}
</style>